import React, { ReactNode } from "react";
import styled, { useTheme } from "styled-components";
import { LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { directionColor, getNewLookTokens } from "common/NewLook/tokens.ts";
import { textWidth } from "common/NewLook/measureText.ts";
import { PRICE_LADDER_CHANGE_ID } from "testIds";

interface LadderPriceChange {
  width: number;
  element: ReactNode;
}

const CHANGE_DIGITS = 2;

const getChangeText = (change: number) => {
  const shown = Number(Math.abs(change).toFixed(CHANGE_DIGITS));
  const arrow = shown ? (change < 0 ? "▼" : "▲") : "";
  return `${arrow}${shown.toFixed(CHANGE_DIGITS)}%`;
};

const useLadderPriceChange = (change?: number): LadderPriceChange => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);
  const tokens = getNewLookTokens(useTheme());
  if (change === undefined) return { width: 0, element: null };
  const value = getChangeText(change);
  const period = t("phone.card_price_change");
  return {
    width: textWidth(` ${value} ${period}`),
    element: (
      <Change data-testid={PRICE_LADDER_CHANGE_ID}>
        <span style={{ color: directionColor(tokens, change) }}>{value}</span>
        <Period>{period}</Period>
      </Change>
    ),
  };
};

export default useLadderPriceChange;

const Change = styled.span`
  display: inline-flex;
  gap: 4px;
  margin-left: 5px;
`;
const Period = styled.span`
  color: ${(p) => getNewLookTokens(p.theme).muted};
  font-weight: 400;
`;
